<template>
  <div class="map-control-panel">
    <template v-if="journeyDay.length > 0">
      <!-- View mode -->
      <template v-if="isComplete">
        <div ref="editorJourneyDay" v-for="(item, index) in journeyDay" :key="index" >
          <EditorJourneyDay :journeyDayData="item" :dayIndex="index + 1" @updated="refresh()" />
        </div>
      </template>

      <!-- Advanced edit mode -->
      <template v-else>
        <AdvancedEditorJourneyDay v-for="(item, index) in journeyDay" :key="index" :journeyDayData="item" :dayIndex="index + 1" @updated="refresh()" @routeConnected="routeConnected(index)"/>
      </template>
    </template>

  </div>
</template>

<script>
import moment from "moment/moment";
import {mapActions, mapGetters} from "vuex";
import EditorJourneyDay from "@/components/MapEditor/EditorJourneyDay.vue";
import AdvancedEditorJourneyDay from "@/components/MapEditor/AdvancedEditorJourneyDay.vue";

export default {
  name: 'MapControlPanel',
  data() {
    return {
      journeyDay: [],
    };
  },
  props: {
  },
  components: {
    EditorJourneyDay,
    AdvancedEditorJourneyDay,
  },
  computed: {
    ...mapGetters('journey', ['journeyData', 'compiledSplitIndexs', 'compiledJourneyArray', 'isComplete', 'durationDays']),
  },
  watch: {
    durationDays(newVal, oldVal) {
      if (newVal !== oldVal && newVal > 0) {
        this.refresh();
      }
    },
  },
  created() {
  },
  async mounted() {
    await this.refresh();
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions(['appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),

    async refresh() {
      this.splitJourney();
      this.insertOperationNodes();
    },
    splitJourney() {
      this.journeyDay.splice(0, this.journeyDay.length);
      if (this.compiledSplitIndexs.length === 0) {
        this.journeyDay.push(this.compiledJourneyArray);
      } else {
        let temp = [];
        let ind = 0;
        for (let i=0;i<this.compiledJourneyArray.length;i++) {
          if (i === this.compiledSplitIndexs[ind]) {
            const tempEnd = {... this.compiledJourneyArray[i]};
            tempEnd.endTimestamp = tempEnd.startTimestamp;
            tempEnd.endTime = moment(tempEnd.endTimestamp).format('YYYY-MM-DD HH:mm');
            temp.push(tempEnd);

            ind += 1;
            this.journeyDay.push(temp);
            temp = [];

            const tempStart = {... this.compiledJourneyArray[i]};
            tempStart.startTimestamp = tempStart.endTimestamp;
            tempStart.startTime = moment(tempStart.startTimestamp).format('YYYY-MM-DD HH:mm');
            temp.push(tempStart);
          } else {
            temp.push(this.compiledJourneyArray[i]);
          }
        }
        this.journeyDay.push(temp);
      }
    },
    insertOperationNodes() {
      this.journeyDay = this.journeyDay.map(dayArray => {
        if (!Array.isArray(dayArray) || dayArray.length === 0) {
          return dayArray;
        }

        const result = [];
        result.push(dayArray[0]);

        for (let i = 1; i < dayArray.length; i++) {
          const prevSerial = i > 1 ? dayArray[i - 2].serial : -1;
          const curr = dayArray[i - 1];
          const next = dayArray[i];

          // ⭐ milestone → milestone，中間插入 operation
          if (curr.type === 'milestone' && next.type === 'milestone') {
            result.push({
              type: 'operation',
              prevSerial: prevSerial,
              currSerial: curr.serial,
              nextSerial: next.serial,
            });
          }

          result.push(next);
        }

        return result;
      });
    },
    timeStampToTime(timestamp) {
      if (!timestamp || typeof timestamp !== 'number' || isNaN(timestamp)) {
        return "--:--"
      }

      const date = new Date(timestamp)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    routeConnected(dayIndex) {
      // console.log(`connected: ${dayIndex}`);
      setTimeout(() => {
        console.log(this.$refs['editorJourneyDay'][dayIndex]);
        this.$refs['editorJourneyDay'][dayIndex].scrollIntoView({block: 'start'});
      }, 300);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.map-control-panel {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1.5rem 3rem;
  .journey-single-day {
    .journey-day-header {
      border-bottom: 1px solid $color-bk-tp-85;
      h3 {
        display: flex;
        align-items: center;
        gap: 1rem;
      }
    }
  }
  .desc {
    color: $color-bk-tp-50;
  }
}
</style>
<style lang="scss">
@import "src/assets/scss/basic";
.map-control-panel {
}
</style>
